// extracted by mini-css-extract-plugin
module.exports = {"panel-head":"_1yCy8KIPo3GyFj77fvBF4L","icon-container":"VbNa6D4YV4TIBH82A-HQL","input-ecommerce":"Nz_LNw7NwOAR3lGNT5WZM"};